function getRespostas(initialValues, values) {
  return Object.entries(initialValues).map(([key]) => ({
    label: key,
    resposta: values[key] || ""
  }));
}

export default getRespostas;